import { Mutation } from 'app/types/mutation'
import { gql } from 'graphql-request'

export const deleteMutation = () => gql`
  mutation delete($id: String!) {
    deleteComment(id: $id) {
      id
      success
      reason
    }
  }
`

export const deleteResult = (data: any) => {
  return data.deleteComment as Mutation
}
